import Interfaces = require('./Core/Interfaces');
import Navigation = require('./Core/Navigation');
import Env = require('./Core/Environment');
import App = require('./Core/App');
import { ExternalLinksInNewWindow } from "./Core/ExternalLinksInNewWindow";
import { CustomerProfileCard } from './Core/CustomerProfileCard';
import { ImageFallback } from './Core/ImageFallback';
import { NavigationScrollHideEffect } from './Core/NavigationScrollHideEffect';
import { CookieBannerPlaceholder } from './Core/CookieBannerPlaceholder';
import { AdminSessionTimer } from './Core/AdminSessionTimer';
import { InputExtensions } from './Core/InputExtensions'
import { ExternalLinksConfirmationDialog } from './Core/ExternalLinksConfirmationDialog';

class AppMain {

    public masterNavigation: Navigation.MasterNavigation;
    public customerProfileCard: CustomerProfileCard;
    public app: App.AppModel;

    run(configFile: Interfaces.IAppConfig): void {
        var self = this;
        //init environment from config.json
        Env.initialize(configFile);
        //init js app context
        var appContext = new App.AppContext();
        //init master navigation
        this.masterNavigation = new Navigation.MasterNavigation($('#masterNavigation')[0]);
        this.customerProfileCard = new CustomerProfileCard();
        // init js app model and load context relevant module
        self.app = new App.AppModel(appContext);
        // Automatically open external links in new tab
        new ExternalLinksInNewWindow();
        // Automatically Calls ModalDialog when extern Link is called
        new ExternalLinksConfirmationDialog();
        // Enable data-fallback attribute for images
        new ImageFallback();
        // Add scroll effect for screens with less than 500px height (phone landscape mode)
        new NavigationScrollHideEffect();
        // Push down the navigation elements if the cookie banner is displayed
        new CookieBannerPlaceholder();

        new InputExtensions();

        new AdminSessionTimer();
    } 
}

export = AppMain